export enum TimeSlot {
  MORNING = 'morning',        // 9:00～11:00
  MIDDAY = 'midday',          // 11:00～12:00
  AFTERNOON = 'afternoon',    // 13:00～15:00
  EVENING = 'evening'         // 15:00～17:00
}

export const getTimeSlotLabel = (timeSlot: string): string => {
  const labelMap: Record<string, string> = {
    [TimeSlot.MORNING]: '9:00～11:00',
    [TimeSlot.MIDDAY]: '11:00～12:00',
    [TimeSlot.AFTERNOON]: '13:00～15:00',
    [TimeSlot.EVENING]: '15:00～17:00',
  }
  return labelMap[timeSlot] || timeSlot
}

